<p class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
<form
  class="kt-form"
  [formGroup]="statmentForm"
  *ngIf="statmentForm"
  autocomplete="off"
>
  <h2 class="page-titel">Fraud Statement</h2>
  <div class="row">
    <div class="form-group col-lg-4">
      <label>Statement Name</label>
      <div class="input-group" style="width: 100%">
        <input
          type="text"
          formControlName="statement_name"
          class="form-control"
          placeholder="Enter Statement Name"
          style="width: 100%"
        />
      </div>
      <div
        class="alert alert-danger"
        *ngIf="formValidator.formErrors.statement_name"
      >
        {{ formValidator.formErrors.statement_name }}
      </div>
    </div>
    <div class="form-group col-lg-4">
      <label>Module name</label>
      <div class="input-group" style="width: 100%">
        <select
          style="border: 1px #cccccc solid; padding: 0.5rem"
          formControlName="statement_module_id"
          class="form-control"
        >
          <option disabled value="null" selected>Choose Module</option>
          <option *ngFor="let module of modules" [value]="module.id">
            {{ module.name }}
          </option>
        </select>
      </div>
      <div
        class="alert alert-danger"
        *ngIf="formValidator.formErrors.statement_module_id"
      >
        {{ formValidator.formErrors.statement_module_id }}
      </div>
    </div>
  </div>
</form>
<form class="kt-form" [formGroup]="conditionForm" autocomplete="off">
  <h2 class="page-titel">Fraud Statement's conditions</h2>
  <div formArrayName="conditions">
    <div
      class="row"
      *ngFor="let condition of conditions.controls; let i = index"
      formGroupName="{{ i }}"
    >
      <div class="form-group col-lg-4">
        <label>Factor</label>
        <div class="input-group" style="width: 100%">
          <select
            style="border: 1px #cccccc solid; padding: 0.5rem"
            formControlName="key"
            (selectionChange)="
              setFactorDep(
                $event.source.ngControl._parent.control,
                $event.value
              )
            "
          >
            <option *ngFor="let factor of factors" [value]="factor.key">
              {{ factor.name }}
            </option>
          </select>
        </div>
        <mat-error *ngIf="condition.get('key').invalid">
          factor is Required
        </mat-error>
      </div>
      <div class="form-group col-lg-4">
        <label>Operation</label>
        <div class="input-group" style="width: 100%">
          <select
            style="border: 1px #cccccc solid; padding: 0.5rem"
            formControlName="op"
          >
            <option
              *ngFor="let operation of operations"
              [value]="operation.value"
            >
              {{ operation.name }}
            </option>
          </select>
        </div>
        <mat-error *ngIf="condition.get('op').invalid">
          operation is Required
        </mat-error>
      </div>
      <div class="form-group col-lg-3">
        <label>Value</label>
        <div class="input-group" style="width: 100%">
          <input
            *ngIf="condition.get('key').value !== timePeriod"
            type="text"
            formControlName="value"
            class="form-control"
            placeholder="Enter Condition value"
            style="width: 100%"
          />
          <input
            *ngIf="condition.get('key').value == timePeriod"
            class="form-control"
            formControlName="value"
            type="datetime-local"
            style="width: 100%"
          />
        </div>
        <mat-error *ngIf="condition.get('value').invalid">
          Value is required
        </mat-error>
      </div>
      <div class="form-group col-lg-1 align-content-centre">
        <button class="btn btn-primary" (click)="removeCondition(i)">
          Remove
        </button>
      </div>
    </div>
  </div>
  <p>
    <button
      type="button"
      class="btn btn-primary float-right"
      (click)="addCondition()"
    >
      Add
    </button>
  </p>
</form>
<button
  [disabled]="formsValidation"
  class="btn btn-primary"
  (click)="sendFormData()"
>
  Save Fraud Statement
</button>
